
//系统目录 / 西药 接口相关的函数
import request from "../../untils/request.js"

/**
 * 
 *  post
 *  
 */

//登录函数
export const login = (data) => {
    return request.post("/outpatient/login",data)
}


/**
 * 
 * get 
 *  
 */

// 树菜单
export const AllTree = (params) => {
    return request.get("/outpatient/selectAllDrugCategory", { params })
}

// 本位码
export const ProductNameCode = (params) => {
    return request.get("/outpatient/selectByProductName", { params })
}

// 通过树形结构为参数比如点击西药就查出西药的数据查询对应的数据
export const getDrugType = (params) => {
    return request.get("/outpatient/getDrugType", { params })
}

// 公共目录的树形结构 （药品类型）
export const selectCateGory = (params) => {
    return request.get("/outpatient/selectCateGory", { params })
}

// 药物类别
export const selectOneCateGory = (params) => {
    return request.get("/outpatient/selectOneCateGory", { params })
}

// 药物类别2级分类 药理子类别
export const selectTwoCateGory = (params) => {
    return request.get("/outpatient/selectTwoCateGory", { params })
}

// 药物类别3级分类 药理3子类别
export const selectThreeCateGory = (params) => {
    return request.get("/outpatient/selectThreeCateGory", { params })
}

// 列表，带条件查询，带分页  => 剂型
export const selectDrugDosageForm = (params) => {
    return request.get("/outpatient/selectDrugDosageForm", { params })
}

// 毒麻类型
export const selectDocVtByType = (params) => {
    return request.get("/outpatient/selectDocVtByType", { params })
}

//病案费别
export const selectExpenseCategory = (params) => {
    return request.get("/outpatient/selectExpenseCategory", { params })
}

/**
 * 
 * DELETE 
 *  
 */   


// 暴露
export default{
AllTree,
ProductNameCode,getDrugType,selectCateGory,selectOneCateGory,selectTwoCateGory,selectThreeCateGory,
selectDrugDosageForm,
selectDocVtByType,selectExpenseCategory
}